import React from "react";
import { isPricingRedesignEnabled } from "../../../../../featureToggles";
import { ByFirstPaymentLegacy } from "./ByFirstPaymentLegacy";
import { ByFirstPaymentModern } from "./ByFirstPaymentModern";

export const ByFirstPayment = (props) => {
    if (isPricingRedesignEnabled) {
        return <ByFirstPaymentModern {...props} />;
    }

    return <ByFirstPaymentLegacy {...props} />;
};
